import { DeductionsReportStatus } from '@aslanpay/portal-common-lib';

export type CompanyDeductionsReportStatus =
  | DeductionsReportStatus
  | 'FINALISING'
  | 'PROCESSED_WITH_WARNINGS';

export const DeductionsReportsStatusValues: Record<
  CompanyDeductionsReportStatus,
  { color: string; value: string }
> = {
  IN_PROGRESS: { color: 'created', value: 'In progress' },
  PROCESSING: { color: 'invited', value: 'Processing' },
  FINALISING: { color: 'invited', value: 'Finalising' },
  PROCESSED: { color: 'active', value: 'Processed' },
  PROCESSED_WITH_WARNINGS: { color: 'warning', value: 'Processed with warnings' },
  FAILED: { color: 'left', value: 'Failed' },
};

export const DownloadableDeductionsReportStatuses: CompanyDeductionsReportStatus[] = [
  'PROCESSED',
  'PROCESSED_WITH_WARNINGS',
];

export default DeductionsReportsStatusValues;
